export default __webpack_public_path__ + "static/media/2.29f680ba.jpg";